import React from "react";
import scrollToComponent from "react-scroll-to-component";
import questions from "./questions.js";
import Beeswarm from "../beeswarm";
import CouncillorsList from "../councillorsList";
import { shareURLFactory } from "@ta-interaktiv/share-url-factory";
import "./styles.scss";
import dictionary from "../dictionary.js";
import Dropdown from "react-dropdown";

const councillorsAnswers = require("../../data.csv");
console.log(councillorsAnswers);

const options = [
  { value: "BE", label: "Berne" },
  { value: "FR", label: "Fribourg" },
  { value: "GE", label: "Genève" },
  { value: "JU", label: "Jura" },
  { value: "NE", label: "Neuchâtel" },
  { value: "VS", label: "Valais" },
  { value: "VD", label: "Vaud" },
  { value: "AG", label: "Argovie" },
  { value: "AI", label: "Appenzell Rhodes-Intérieures" },
  { value: "AR", label: "Appenzell Rhodes-Extérieures" },
  { value: "BS", label: "Bâle-Ville" },
  { value: "BL", label: "Bâle-Campagne" },
  { value: "GL", label: "Glaris" },
  { value: "GR", label: "Grisons" },
  { value: "LU", label: "Lucerne" },
  { value: "NW", label: "Nidwald" },
  { value: "OW", label: "Obwald" },
  { value: "SH", label: "Schaffhouse" },
  { value: "SZ", label: "Schwyz" },
  { value: "SO", label: "Soleure" },
  { value: "SG", label: "Saint-Gall" },
  { value: "TU", label: "Thurgovie" },
  { value: "TI", label: "Tessin" },
  { value: "UR", label: "Uri" },
  { value: "ZG", label: "Zoug" },
  { value: "ZH", label: "Zurich" }
];

function AnswerButton(props) {
  return (
    <div
      onClick={() => {
        props.clickHandler(props.value);
      }}
      className={"ui answer button" + (props.active ? " active" : "")}
    >
      {props.label}
    </div>
  );
}

function CouncillorPortrait(props) {
  return (
    <div className="item councillor-portrait">
      <div className="portrait">
        <div className="portrait-picture">
          <img
            src={require("./../images/councillors/" +
              props.councillor["CouncillorId"] +
              ".png")}
          />
        </div>
        <div className="portrait-bck" />
      </div>
      <div className="content">
        <div className="header">
          <div className="councillor-name">
            {props.councillor["CouncillorName"]}{" "}
            <span style={{ fontWeight: "200" }}>
              ({props.councillor["Canton"]})
            </span>
          </div>{" "}
          du groupe{" "}
          <b>
            {
              dictionary.parliamentaryGroups[
                props.councillor["Groupe parlementaire"]
              ]
            }
          </b>{" "}
          fait partie des parlementaires{" "}
          <span className="color">les plus {props.adj} de vous</span> avec{" "}
          <b>{Math.round(props.councillor["score"] * 1000) / 10}%</b> de votes
          identiques sur l'ensemble des objets proposés jusqu'ici.
        </div>{" "}
      </div>
      {/* !props.fromSelectedCanton && (
        <div className="small-note">
          Aucun parlementaire de votre canton n'a été trouvé parmi les scores
          les plus {props.adj} de vous. Nous en avons choisi un au hasard.
        </div>
      ) */}
    </div>
  );
}

function getUrl() {
  // Completely reconstruct the URL from it's parts
  return `${window.location.origin}/2019/parlementaires`;
  // return `${window.location.origin}${window.location.pathname}`;
}

class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCloseCouncillor: true,
      answered: false,
      hideQuestion: false,
      showResult: false
    };
    this.handleAnswer = this.handleAnswer.bind(this);
    this.handleGroupChange = this.handleGroupChange.bind(this);
  }

  // Construct the questions objects from the data
  // {questionId: answer}
  getQuestions() {
    let out = {};

    // Get the csv columns
    let columns = Object.keys(councillorsAnswers[0]);

    // Keep only the votes
    let votes = columns.toString().match(/\d+/g);

    // Constructs the user answers object
    votes.forEach(v => {
      out[v] = null;
    });

    return out;
  }

  // Get a slice of the nearest and farthest councillors.
  // We want to show the councillors from these cantons first.
  getNearestCouncillors(councillors) {
    /* const cantonsOrder = [
      "VD",
      "GE",
      "VS",
      "FR",
      "JU",
      "NE",
      "BE",
      "ZH",
      "Others"
    ]; */

    // Get the maximum and minium score among the councillors
    let maxScore = Math.max(...councillors.map(o => o.score));
    let minScore = Math.min(...councillors.map(o => o.score));

    // Get a slice of the nearest and farthest councillors
    let councillorsSlice = {
      top: councillors.filter(c => c.score === maxScore),
      bottom: councillors.filter(c => c.score === minScore)
    };
    /*
    // The scores slice arrays
    let topOut = [];
    let bottomOut = [];

    // Order the nearest councillors by canton
    let orderedCouncillors = Array.from(
      { length: cantonsOrder.length },
      () => []
    );
    nearestTopCouncillors.forEach(c => {
      let ic = cantonsOrder.indexOf(c["Canton"]);
      if (ic === -1) {
        ic = cantonsOrder.indexOf("Others");
      }
      orderedCouncillors[ic].push(c);
    });
    orderedCouncillors.forEach(c => {
      topOut = topOut.concat(c);
    });
    */

    let selectedCantonSliceTop = councillorsSlice.top.filter(e => {
      return (
        e["Canton"] ===
        (this.state.selectedCanton ? this.state.selectedCanton : "BE")
      );
    });

    let selectedCantonSliceBottom = councillorsSlice.bottom.filter(e => {
      return (
        e["Canton"] ===
        (this.state.selectedCanton ? this.state.selectedCanton : "BE")
      );
    });

    let randomCouncillor = {
      top: {
        councillor: null,
        fromSelectedCanton: null
      },
      bottom: {
        councillor: null,
        fromSelectedCanton: null
      }
    };

    console.log(
      "Nearest slice for the selected canton (max: ",
      maxScore,
      "min: ",
      minScore,
      ")"
    );
    console.log("TOP", this.state.selectedCanton, selectedCantonSliceTop);
    console.log("BOTTOM", this.state.selectedCanton, selectedCantonSliceBottom);

    if (selectedCantonSliceTop.length > 0) {
      randomCouncillor.top = {
        councillor:
          selectedCantonSliceTop[
            Math.floor(Math.random() * selectedCantonSliceTop.length)
          ],
        fromSelectedCanton: true
      };
    } else {
      randomCouncillor.top = {
        councillor:
          councillorsSlice.top[
            Math.floor(Math.random() * councillorsSlice.top.length)
          ],
        fromSelectedCanton: false
      };
    }

    if (selectedCantonSliceBottom.length > 0) {
      randomCouncillor.bottom = {
        councillor:
          selectedCantonSliceBottom[
            Math.floor(Math.random() * selectedCantonSliceBottom.length)
          ],
        fromSelectedCanton: true
      };
    } else {
      randomCouncillor.bottom = {
        councillor:
          councillorsSlice.bottom[
            Math.floor(Math.random() * councillorsSlice.bottom.length)
          ],
        fromSelectedCanton: false
      };
    }

    // Order the farthest councillors by canton
    /* orderedCouncillors = Array.from({ length: cantonsOrder.length }, () => []);
    nearestBottomCouncillors.forEach(c => {
      let ic = cantonsOrder.indexOf(c["Canton"]);
      if (ic === -1) {
        ic = cantonsOrder.indexOf("Others");
      }
      orderedCouncillors[ic].push(c);
    });
    orderedCouncillors.forEach(c => {
      bottomOut = bottomOut.concat(c);
    }); */

    return {
      /* top: topOut,
      bottom: bottomOut, */
      randomTop: randomCouncillor.top,
      randomBottom: randomCouncillor.bottom
    };
  }

  componentWillMount() {
    let storedCanton = window.localStorage.getItem("selectedCanton");
    let storedGroup = window.localStorage.getItem("selectedGroup");
    let storedAnswers = window.localStorage.getItem("userAnswers");

    console.log(storedCanton, storedGroup, storedAnswers);

    this.setState(
      {
        showCantonDropdown: storedCanton === null,
        selectedCanton: storedCanton || null,
        selectedGroup: storedGroup || "V",
        userAnswers: storedAnswers
          ? JSON.parse(storedAnswers)
          : this.getQuestions()
      },
      () => {
        console.log(this.state);
      }
    );
  }

  componentDidUpdate(oldProps, oldState) {
    if (this.state.hideQuestion !== oldState.hideQuestion) {
      scrollToComponent(this.node, { align: "top" });
    }

    if (
      this.props.match.params.questionId !== oldProps.match.params.questionId
    ) {
      this.reset();
    }
  }

  reset() {
    this.setState({
      showCloseCouncillor: true,
      answered: false,
      hideQuestion: false,
      showResult: false
    });
  }

  handleAnswer(value) {
    let userAnswers = this.state.userAnswers;
    // Get the answer by its number and assign it the user value
    userAnswers[
      Object.keys(userAnswers)[this.props.match.params.questionId - 1]
    ] = value;

    console.log(
      "Vote n",
      Object.keys(userAnswers)[this.props.match.params.questionId - 1],
      ": " + value,
      "(" + dictionary.answers[value] + ")"
    );
    console.log("Answers so far:");
    console.log(userAnswers);

    // Used to trigger the confirmation animation
    this.setState({
      answered: true
    });

    // Store the answers
    window.localStorage.setItem("userAnswers", JSON.stringify(userAnswers));

    // Change the state once the confirmation animation is done
    setTimeout(() => {
      this.setState({
        userAnswers: userAnswers,
        hideQuestion: true,
        showResult: true
      });
    }, 350);

    // GA tracking
    /* eslint-disable */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Interactions",
      event_action: "click",
      event_label: "Question: " + this.props.match.params.questionId
    });
    /* eslint-enable */
  }

  getVoteResult() {
    // Get the vote id according to the current question id
    let voteId = Object.keys(this.state.userAnswers)[
      this.props.match.params.questionId - 1
    ];
    // Get the user answer
    let answer = this.state.userAnswers[voteId];
    // Keep only the councillors that have the same answer
    let filteredCouncillors = councillorsAnswers.filter(
      c => +c[voteId] === answer && +c[voteId] !== 0
    );
    // All the votes
    let allCouncillors = councillorsAnswers.map(item => {
      return {
        CouncillorName: item["CouncillorName"],
        "Groupe parlementaire": item["Groupe parlementaire"],
        Canton: item["Canton"],
        Vote: item[voteId]
      };
    });

    return {
      parliamentaryGroups: this.getParliamentaryGroupsActive(
        filteredCouncillors
      ),
      councillors: filteredCouncillors,
      allCouncillors: allCouncillors.sort((a, b) =>
        a["CouncillorName"].localeCompare(b["CouncillorName"])
      )
    };
  }

  getVoteId() {
    return Object.keys(this.state.userAnswers)[
      this.props.match.params.questionId - 1
    ];
  }

  // Method used to score each councillor, should be the only one used
  filterCouncillors() {
    console.log(this.state.userAnswers);
    let filteredCouncillors = [...councillorsAnswers];

    let answersCount = Object.keys(this.state.userAnswers).filter(
      a => this.state.userAnswers[a] !== null
    ).length;

    filteredCouncillors.forEach(c => {
      c["score"] = 0;
      c["same"] = 0;
      // c["votesCount"] = 0;

      for (let voteId in this.state.userAnswers) {
        let userAnswer = this.state.userAnswers[voteId];
        if (userAnswer) {
          // We need to count only the votes were the councillor was present
          // +c[voteId] !== 0 && c["votesCount"]++;

          c["same"] = +c[voteId] === userAnswer ? c["same"] + 1 : c["same"];
          // c["score"] = c["votesCount"] > 0 ? c["same"] / c["votesCount"] : 0;
          c["score"] = c["same"] / answersCount;
        }
      }
    });

    filteredCouncillors.sort((a, b) => {
      if (b["score"] < a["score"]) return -1;
      if (b["score"] > a["score"]) return 1;
      if (b["CouncillorName"] > a["CouncillorName"]) return -1;
      if (b["CouncillorName"] < a["CouncillorName"]) return 1;
    });

    return {
      parliamentaryGroups: this.getParliamentaryGroupsPct(filteredCouncillors),
      councillors: filteredCouncillors,
      exact: filteredCouncillors.filter(c => c["score"] === 1).length
    };
  }

  getClasses() {
    let classText = "question-container";
    this.state.showResult && (classText += " show-result");
    this.state.hideQuestion && (classText += " hide-question");
    this.state.answered && (classText += " answered");
    return classText;
  }

  handleGroupChange(group) {
    window.localStorage.setItem("selectedGroup", group);
    this.setState({
      selectedGroup: group
    });

    // GA tracking
    /* eslint-disable */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Interactions",
      event_action: "click",
      event_label: "Selected group: " + group
    });
    /* eslint-enable */
  }

  getParliamentaryGroupsCount(councillors) {
    let counts = {};

    councillors.forEach(c => {
      counts[c["Groupe parlementaire"]] =
        (counts[c["Groupe parlementaire"]] || 0) + 1;
    });

    return counts;
  }

  getParliamentaryGroupsActive(councillors) {
    let counts = {};
    let total = this.getParliamentaryGroupsCount(
      councillorsAnswers.filter(c => +c[this.getVoteId()] !== 0)
    );
    let parliamentaryGroupsList = [];

    councillors.forEach(c => {
      counts[c["Groupe parlementaire"]] =
        (counts[c["Groupe parlementaire"]] || 0) + 1;
    });

    Object.keys(counts).forEach(c => {
      counts[c] = Math.round((counts[c] / total[c]) * 1000) / 10;
    });
    Object.keys(counts).map(item => {
      parliamentaryGroupsList.push({
        name: item,
        pct: counts[item],
        total: total[item]
      });
    });

    parliamentaryGroupsList.sort((a, b) => b["pct"] - a["pct"]);
    return parliamentaryGroupsList;
  }

  getParliamentaryGroupsPct(councillors) {
    let counts = {};
    let total = this.getParliamentaryGroupsCount(councillors);
    let parliamentaryGroupsArray = [];

    this.getParliamentaryGroupsCount(councillorsAnswers);

    councillors.forEach(c => {
      counts[c["Groupe parlementaire"]] =
        (counts[c["Groupe parlementaire"]] || 0) + c["score"];
    });

    Object.keys(counts).forEach(c => {
      counts[c] = Math.round((counts[c] / total[c]) * 1000) / 10;
    });
    Object.keys(counts).map(item => {
      parliamentaryGroupsArray.push({
        name: item,
        pct: counts[item],
        total: total[item]
      });
    });

    parliamentaryGroupsArray.sort((a, b) => b["pct"] - a["pct"]);
    return parliamentaryGroupsArray;
  }

  render() {
    const question = questions[this.getVoteId()];
    const filteredCouncillors = this.filterCouncillors();
    const thisVoteFilteredCouncillors = this.getVoteResult();
    const nearestCouncillors = this.getNearestCouncillors(
      filteredCouncillors.councillors
    );
    const answerCount = Object.keys(this.state.userAnswers).filter(
      a => this.state.userAnswers[a] !== null
    ).length;
    const shareText = `${
      this.state.showCloseCouncillor
        ? nearestCouncillors.randomTop.councillor["CouncillorName"]
        : nearestCouncillors.randomBottom.councillor["CouncillorName"]
    } a des opinions politiques ${
      this.state.showCloseCouncillor ? "proches" : "à l'opposé"
    } des miennes. Et vous?`;
    const twitterConfig = {
      title: shareText,
      url: getUrl()
    };
    const twitterShareUrl = shareURLFactory.twitter(twitterConfig);
    const results = (
      <div className="results">
        <div className="ui text container result-card">
          <div className="chart-title">
            <span className="color">
              {thisVoteFilteredCouncillors.councillors.length > 0
                ? Math.round(
                    (thisVoteFilteredCouncillors.councillors.length /
                      councillorsAnswers.length) *
                      1000
                  ) /
                    10 +
                  "%"
                : "Aucun"}
            </span>{" "}
            des parlementaires ont voté comme vous sur cet objet{" "}
          </div>
          <div className="ui padded raised segment">
            <div className="chart-subtitle">
              Proportion, par groupe parlementaire, des conseillers nationaux
              qui ont voté comme vous
            </div>
            <ul className="parliamentary-groups">
              {thisVoteFilteredCouncillors.parliamentaryGroups.map((p, i) => (
                <li
                  key={"parliamentaryGroup-" + i}
                  className={p["pct"] > 50 ? "majority" : ""}
                >
                  <div>{dictionary.parliamentaryGroups[p["name"]]}</div>
                  <div className="pct-bar">
                    <div style={{ width: p["pct"] + "%" }} />
                  </div>
                  <div>
                    <span style={{ fontWeight: "200" }}>{p["pct"]}%</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="ui text container">
          <CouncillorsList
            type="current"
            councillors={thisVoteFilteredCouncillors.allCouncillors}
          />
        </div>

        <div className="ui text container result-card nearest-councillor">
          <div className="ui very fitted vertical segment center aligned">
            <div className="ui stackable grid">
              {this.state.showCloseCouncillor && (
                <div className="ten wide centered column">
                  <div className="ui very relaxed">
                    <CouncillorPortrait
                      adj={"proches"}
                      fromSelectedCanton={
                        nearestCouncillors.randomTop.fromSelectedCanton
                      }
                      councillor={nearestCouncillors.randomTop.councillor}
                    />
                  </div>
                </div>
              )}
              {!this.state.showCloseCouncillor && (
                <div className="ten wide centered column">
                  <div className="ui very relaxed">
                    <CouncillorPortrait
                      adj={"éloignés"}
                      fromSelectedCanton={
                        nearestCouncillors.randomBottom.fromSelectedCanton
                      }
                      councillor={nearestCouncillors.randomBottom.councillor}
                    />
                  </div>
                </div>
              )}
            </div>
            <div style={{ marginTop: "2em" }}>
              <div
                className={"ui answer button active"}
                onClick={() => {
                  // GA tracking
                  /* eslint-disable */
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "Interactions",
                    event_action: "click",
                    event_label: "Show close: " + this.state.showCloseCouncillor
                  });
                  /* eslint-enable */

                  this.setState(prevState => {
                    return {
                      showCloseCouncillor: !prevState.showCloseCouncillor
                    };
                  });
                }}
              >
                <i className="exchange icon" />
                {this.state.showCloseCouncillor
                  ? "Ils ont d'autres opinions"
                  : "Qui pense comme vous?"}
              </div>
              <div className={"ui answer button active"}>
                <a
                  href={twitterShareUrl}
                  onClick={() => {
                    // GA tracking
                    /* eslint-disable */
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "Interactions",
                      event_action: "click",
                      event_label: "Share"
                    });
                    /* eslint-enable */
                    return false;
                  }}
                  className="ui bottom attached"
                >
                  <i className="twitter icon" /> Partager
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="ui container">
          <div className="ui raised padded segment">
            <div className="chart-header ui stackable grid">
              <div className="ten wide column">
                {answerCount > 1 ? (
                  <div className="chart-title">
                    {filteredCouncillors.exact ? (
                      <span className="color">
                        {Math.round(
                          (filteredCouncillors.exact /
                            councillorsAnswers.length) *
                            1000
                        ) /
                          10 +
                          "%"}
                      </span>
                    ) : (
                      ""
                    )}{" "}
                    <span>
                      {filteredCouncillors.exact ? (
                        "des parlementaires ont"
                      ) : (
                        <span>
                          <span className="color">Personne</span> n'a
                        </span>
                      )}
                    </span>{" "}
                    voté comme vous
                    {answerCount < 2 ? (
                      ""
                    ) : (
                      <span>
                        {" "}
                        sur les{" "}
                        <span className="">{answerCount}&nbsp;objets</span>{" "}
                        proposés jusqu'ici
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="chart-title">
                    Voici ce que l'on peut vous montrer jusqu'ici.{" "}
                    <span className="color">Continuez à voter</span> pour
                    affiner le résultat.
                  </div>
                )}
                <div className="chart-subtitle">
                  Où se situent les 200 conseillers nationaux par rapport à
                  vous?
                </div>
              </div>
            </div>
            <Beeswarm
              handleGroupChange={this.handleGroupChange}
              selectedGroup={this.state.selectedGroup}
              data={filteredCouncillors.councillors}
            />
            {answerCount > 1 && (
              <div className="ui very fitted vertical segment pgroups-container">
                <ul className="parliamentary-groups">
                  {filteredCouncillors.parliamentaryGroups.map((p, i) => (
                    <li
                      key={"parliamentaryGroup-mean-" + i}
                      className={p["pct"] > 50 ? "majority" : ""}
                    >
                      <div>{dictionary.parliamentaryGroups[p["name"]]}</div>
                      <div className="pct-bar">
                        <div
                          className="pct-bar-active"
                          style={{ width: p["pct"] + "%" }}
                        />
                        <div className="pct-bar-background" />
                      </div>
                      <div>
                        <span style={{ fontWeight: "200" }}>{p["pct"]}%</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="ui stackable grid chart-footer">
              <div className="ten wide column">
                <div className="chart-notes">
                  Un parlementaire absent ou excusé lors d'un vote est compté
                  dans le calcul de la moyenne des votes similaires. Par
                  exemple, un parlementaire absent lors du premier vote, puis
                  qui vote comme vous au prochain, obtiendra un score de 50%.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ui text container">
          <CouncillorsList
            type="mean"
            councillors={filteredCouncillors.councillors}
          />
        </div>

        <div
          style={{ position: answerCount < 15 ? "sticky" : "relative" }}
          className="ui text raised segment container sticky-next-vote-button"
        >
          <div
            style={{
              width:
                (this.props.match.params.questionId /
                  Object.keys(questions).length) *
                  100 +
                "%"
            }}
            className="border-step"
          />
          {answerCount < 15 ? (
            <div
              className="ui secondary right labeled icon answer button"
              onClick={() => {
                this.props.history.push(
                  "/question/" +
                    ((parseInt(this.props.match.params.questionId) %
                      Object.keys(questions).length) +
                      1)
                );
              }}
            >
              <i className="right chevron icon" />
              Continuez à voter
            </div>
          ) : (
            <div
              className="ui secondary right labeled icon answer button"
              onClick={() => {
                console.log("RESET");
                window.localStorage.clear();
                this.setState({
                  selectedCanton: null,
                  selectedGroup: "V",
                  userAnswers: this.getQuestions()
                });

                // GA tracking
                /* eslint-disable */
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "Interactions",
                  event_action: "click",
                  event_label: "Reset"
                });
                /* eslint-enable */

                this.props.history.push("/question/1");
              }}
            >
              <i className="right chevron icon" />
              Recommencer
            </div>
          )}
        </div>
      </div>
    );
    const AnswerButtons = (
      <div className="answers ui center aligned text container">
        <AnswerButton
          active={this.state.userAnswers[this.getVoteId()] === 1}
          value={1}
          label="Oui"
          clickHandler={value => {
            this.handleAnswer(value);
          }}
        />
        <AnswerButton
          active={this.state.userAnswers[this.getVoteId()] === 2}
          value={2}
          label="Non"
          clickHandler={value => {
            this.handleAnswer(value);
          }}
        />
        <AnswerButton
          active={this.state.userAnswers[this.getVoteId()] === 3}
          value={3}
          label="Abs."
          clickHandler={value => {
            this.handleAnswer(value);
          }}
        />
      </div>
    );

    return (
      <div
        className={this.getClasses()}
        ref={node => {
          this.node = node;
        }}
      >
        {this.state.showCantonDropdown && (
          <div
            className="ui container canton-dropdown"
            style={{
              height: this.state.selectedCanton ? "0px" : "190px",
              overflow: this.state.selectedCanton ? "hidden" : "visible"
            }}
          >
            <div className="ui vertical fitted segment center aligned">
              <div className="intro-text-action">
                <div style={{ fontWeight: "bold" }}>
                  Choisissez votre canton
                </div>
                <div
                  style={{
                    fontSize: ".65em",
                    marginTop: ".45em",
                    lineHeight: "1.2em",
                    color: "#90939c"
                  }}
                >
                  Nous essayerons de vous montrer les parlementaires de ce
                  canton en priorité.
                </div>
              </div>
              <Dropdown
                options={options}
                onChange={option => {
                  window.localStorage.setItem("selectedCanton", option.value);
                  this.setState({
                    selectedCanton: option.value
                  });
                  // Confirmation animation
                  setTimeout(() => {
                    this.setState({
                      showCantonDropdown: false
                    });
                  }, 1500);

                  // GA tracking
                  /* eslint-disable */
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "Interactions",
                    event_action: "click",
                    event_label: "Selected canton: " + option.value
                  });
                  /* eslint-enable */
                }}
                value={options[0]}
                placeholder="Choisissez un canton"
              />
            </div>
          </div>
        )}
        {/* <div className="ui basic segment center aligned">
          <div className="stage-text-main">
            {this.state.hideQuestion
              ? "Résultat du vote"
              : "Votez pour cet objet"}
          </div>
        </div> */}
        {this.state.hideQuestion ? (
          results
        ) : (
          <div>
            <div className="question ui text container tall stacked segment">
              <div className="question-inner">
                <div className="question-label">
                  <div className="question-sub">{question[0]}</div>
                  <div className="question-header">{question[1]}</div>
                </div>
                <div className="question-text">
                  <p>{question[2]}</p>
                </div>
              </div>
              <div className="question-footer">
                <div>
                  {question[3].object} - {question[3].type} - Vote n°{" "}
                  {question[3].vote} du {question[3].date}
                </div>
                <div className="stage-text-sub">
                  {this.props.match.params.questionId}/
                  {Object.keys(questions).length}
                </div>
              </div>
            </div>
            {AnswerButtons}
          </div>
        )}
      </div>
    );
  }
}

export default Question;
